module.exports = __webpack_public_path__ + "static/340FFF_8_0-7f651756f1f4e6414afc3c0bb62ca8d3.woff2";